import React, { useEffect, useState } from 'react';
import { SchoolClassesConfig } from '../../types/schoolConfigType';
import { SnackbarSeverityType } from '../../enums';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { getSchoolClassesConfig } from '../../apis/schoolConfig';
import { PageContainer } from '../ScoringTypes/styled';
import { Box, Typography } from '@mui/material';
import ToastMessage from '../../components/ToastMessage';
import AssessmentOverviewPage from './AssessmentOverviewPage';

const AssessmentOverviewContainer = () => {
  const [allClasses, setAllClasses] = useState<SchoolClassesConfig>();
  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState<SnackbarSeverityType>(
    SnackbarSeverityType.success
  );
  const [isLoadingConfig, setIsLoadingConfig] = useState(true);

  const handleCloseToast = () => {
    setToastOpen(false);
  };

  const showToast = (message: string, severity: SnackbarSeverityType) => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  useEffect(() => {
    getSchoolClassesConfig(loggedInUser.school)
      .then((response) => {
        setAllClasses(response.data as SchoolClassesConfig);
      })
      .catch((error) => {
        console.error(error);
        showToast(
          'Failed to load school configuration.',
          SnackbarSeverityType.error
        );
      })
      .finally(() => {
        setIsLoadingConfig(false);
      });
  }, [loggedInUser.school]);

  if (isLoadingConfig) {
    return (
      <PageContainer>
        <Typography>Loading assessment overview configuration...</Typography>
      </PageContainer>
    );
  }
  return (
    <Box>
      <AssessmentOverviewPage
        allClasses={allClasses}
        school={loggedInUser?.school}
        onShowToast={showToast}
      />
      <ToastMessage
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={handleCloseToast}
      />
    </Box>
  );
};

export default AssessmentOverviewContainer;
